import { useSearchParams } from 'next/navigation'

import { isBrandCategoryMetas, isBrandMetas, isCategoryMetas, isFacetMetas, isTagMetas } from './type-guards'
import { useBasicMetas } from './use-basic-metas'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPPages } from '../types'

export function usePageTitle() {
    const searchParams = useSearchParams()
    const { page } = usePLPFacetsContext()
    const { basicMetas } = useBasicMetas()

    if (page === PLPPages.Search) {
        const query = searchParams.get('query')
        return query ? `نتایج جست‌وجو برای "${query}"` : 'نتایج جست‌وجو'
    }

    if (!basicMetas) return null

    switch (page) {
        case PLPPages.Brands:
            return isBrandMetas(basicMetas) ? basicMetas.nameFa || '' : ''

        case PLPPages.Categories:
            return isCategoryMetas(basicMetas) ? basicMetas.nameFa || '' : ''

        case PLPPages.Combination: {
            if (isBrandCategoryMetas(basicMetas)) {
                return `${basicMetas.category?.nameFa} ${basicMetas.brand?.nameFa}`
            }
            return ''
        }
        case PLPPages.Tags:
            return isTagMetas(basicMetas) ? basicMetas.seoH1 || '' : ''
        case PLPPages.Facets:
            return isFacetMetas(basicMetas) ? basicMetas.seoH1 || '' : ''
    }
}
